import { WidgetUUID } from '@/common/utils';

interface Listener {
  id: string;
  publish(event: string): void;
}

abstract class Observer {
  abstract subscribe(v: Listener): void;

  abstract unsubscribe(id: string): void;

  abstract notify(): void;
}

export class WidgetObserver extends Observer {
  private listeners: Listener[] = [];

  override subscribe(v: Listener): void {
    this.listeners.push(v);
  }

  override unsubscribe(widgetUUID: WidgetUUID): void {
    this.listeners = this.listeners.filter((v) => v.id !== widgetUUID);
  }

  override notify(): void {
    this.listeners.forEach((v) => v.publish('refetch'));
  }

  hasListener(widgetUUID: string): boolean {
    return this.listeners.some((v) => v.id === widgetUUID);
  }

  hasListeners(): boolean {
    return this.listeners.length > 0;
  }

  getListerners(): Listener[] {
    return this.listeners;
  }
}
